const toggleShowPassword = ({ currentTarget }) => {
  const text_show = `Show password`;
  const text_hide = `Hide password`;
  const $inputRefrence = $($(currentTarget).attr('toggle-show-password'));
  const isCurrentTypePassword = $inputRefrence.attr('type') === 'password';

  $inputRefrence.attr('type',
    isCurrentTypePassword ? 'text' : 'password'
  )

  $(currentTarget).html(isCurrentTypePassword ? text_show : text_hide);
}

const onClickItemsPerPage = ({ currentTarget }) => {
  const value = $(currentTarget).attr('data-value');
  const hasGoToProduct = $(currentTarget).attr('data-go-to-product');
  Shopify.queryParams.per_page = value;
  if (Shopify.queryParams.page) {
    delete Shopify.queryParams.page;
  }
  if(hasGoToProduct) {
    const { COLLECTION_CONFIG: { LOCAL_STORAGE } } = window.smk.collection;
    localStorage.setItem(LOCAL_STORAGE.SCROLL_TO_PRODUCT, parseInt(value/2)+1);
  }
  location.search = decodeURIComponent(
    jQuery.param(Shopify.queryParams)
  );
}

const goNextPageWithParams = (e) => {
  e.stopPropagation();
  e.preventDefault();

  let paramString = $(e.currentTarget).attr('href').split('?')[1];
  let queryString = new URLSearchParams(paramString)
  Shopify.queryParams.page = queryString.get('page');

  location.search = decodeURIComponent(
    jQuery.param(Shopify.queryParams)
  );
  return false;
}

const handleClickFilterOnCollection = ({ currentTarget }) => {
  const type = $(currentTarget).attr('data-filter-type');
  const action = $(currentTarget).attr('data-filter-action');
  const option = $(currentTarget).attr('data-filter-option');
  const value = $(currentTarget).attr('data-filter-value');

  if(type === 'list' || type === 'tags') {
    const currentFilter = Shopify.queryParams[option] ? Shopify.queryParams[option] : '';
    let currentFilterOptions = currentFilter.split(',');

    if(action === 'remove') {
      currentFilterOptions = currentFilterOptions.filter((optionItem) => optionItem !== value);
    } else {
      currentFilterOptions.push(value);
    }

    currentFilterOptions = currentFilterOptions.reduce((acc,item)=>{
      if(!acc.includes(item) && item) {
        acc.push(item);
      }
      return acc;
    },[]);

    Shopify.queryParams[option] = currentFilterOptions.join();
  } else {
    const optionMin = $(currentTarget).attr('data-filter-option-min');
    const optionMax = $(currentTarget).attr('data-filter-option-max');
    const valueMin = $(currentTarget).attr('data-filter-min-value');
    const valueMax = $(currentTarget).attr('data-filter-max-value');

    if(action === 'remove') {
      delete Shopify.queryParams[optionMin];
      delete Shopify.queryParams[optionMax]
    } else {
      Shopify.queryParams[optionMin] = valueMin;
      Shopify.queryParams[optionMax] = valueMax;
    }
  }

  if (Shopify.queryParams.page) {
    delete Shopify.queryParams.page;
  }

  location.search = decodeURIComponent(
    jQuery.param(Shopify.queryParams)
  );

}

const toggleShowFilters = ({ currentTarget }) => {
  const $parent = $(currentTarget).parent().closest('.content-filter');
  $parent.toggleClass('active');
  window.localStorage.setItem(`filter-${$parent.attr('data-filter-content')}-is-active`, $parent.hasClass('active') === true );
}

const toggleMainMenu = () => {
  $('#ContentMainHeaderMobile').toggleClass('active');
  $('html').toggleClass('menu-mobile-active');
}

const toggleShowSubMenu = ({ currentTarget }) => {
  $(currentTarget).parent().closest('.site-nav-has-submenu').toggleClass('active');
}

const dataActionAddClass = (element) => {
  const $elem = $(element);
  const location = $elem.data('action-add-class');

  try {
    $elem.addClass(eval(location))
  } catch (error) {
    window.smkDevUtils.debbuger({
      type: 'error',
      text: 'dataActionAddClass::fn'
    }, {elem: element, err: error});
  }

}

const goToElement = ($elementRef, time) => {
  $([document.documentElement, document.body]).animate({
    scrollTop: $elementRef ? $elementRef.offset().top : 0
  }, time || 'slow');
}

const handleRemoveCartItem = (id) => {
  const { remove } = window.smk.cart;
  remove(id)
}

$(document).ready(() => {

  const { components: { miniCart } } = window.smk.config;

  $('body').on('click', '.action-toogle-mobile-menu', toggleMainMenu);

  $('body').on('click', '.site-nav-has-submenu .btn-link', toggleShowSubMenu);

  $('body').on('click', '[toggle-show-password]', toggleShowPassword);

  $('body').on('click', '.itemsPerPage .item-value', onClickItemsPerPage);

  $('body').on('click', '.go-next-page-with-parrams', goNextPageWithParams);

  $('body').on('click', '[data-filter]', handleClickFilterOnCollection);

  $('body').on('click', '.content-filters-wrapper .content-filter .filter-title', toggleShowFilters);

  $('body').on('click', `${miniCart.btnRemoveItemRef}`, (event) => {
    handleRemoveCartItem($(event.currentTarget).data(miniCart.removeItemRefGetDataId))
  });

  $('body').on('click', 'form[data-parsley-validate] *[type="submit"]', (event) => {
    event.preventDefault();
    const $form = $( event.target ).closest( "form" );
    if($form.parsley().validate()) {
      $form.submit();
    }
  });

  $('.content-filters-wrapper .content-filter[data-filter-content]').each((index, element) => {
    const $element = $(element);
    if(window.localStorage.getItem(`filter-${$element.attr('data-filter-content')}-is-active`) == 'true') {
      $element.addClass('active');
    }
  });


  $('[data-action-add-class]').each((index, element) => {
    dataActionAddClass(element)
  });

  $('[go-to-top]').click(() => {
    goToElement();
  });

  $(window).scroll(function (event) {
    if($(window).scrollTop() >= ($(window).height()/2)) {
      $('[go-to-top]').fadeIn(500)
    } else {
      $('[go-to-top]').fadeOut(500);
    }


    // if($('.content-main-detail-product-wrapper').length) {
    //   let max = $('.content-main-detail-product-wrapper')[0].scrollHeight;

    //   if($(window).scrollTop() + 120 >= max) {
    //     $('.great_sticky').show();
    //   } else {
    //     $('.great_sticky').hide();
    //   }
    // }

    if($(window).scrollTop() >= 25) {
      $('#ContentMainHeaderMobile').addClass('dark');
    } else {
      $('#ContentMainHeaderMobile').removeClass('dark');
    }

  });
});


  document.addEventListener('DOMContentLoaded', function() {

    setTimeout(() => {
      const { getQuickAdd } = window.smk.product;
      const { components: { mainHeader, sizeGuide } } = window.smk.config;
      const $body = $('body');
      let $mainHeader = $(mainHeader.reference);


      if($( window ).width() <= parseInt("1024px")) {
        $mainHeader = $(mainHeader.referenceMobile);
      }

      const $shoppingFreeDeliveryAnnouncementBarWrapper = $('.shopping-free-delivery-announcement-bar-wrapper');

      // $('.product-card-wrapper').hover((event) => {
      //   var $contentQuickAdd = $(event.currentTarget).find('.content-quick-add[data-product-id]');
      //   console.info('contentQuickAdd product-id', $contentQuickAdd.data('product-id'));
      // });

      const handleGetQuickAdd = (event) => {
        var $productCard = $(event.currentTarget);
        var productId = $(event.currentTarget).data('product-id');
        $(`.product-card-wrapper[data-product-id]:not([data-product-id="${productId}"]) .content-quick-add`).removeClass('active').html('');

        if(!$(event.currentTarget).find('.content-quick-add').html()) {
          getQuickAdd(productId)
            .then(function(html) {
              $('.content-quick-add').removeClass('active').html('');
              $('.content-quick-add', $productCard).addClass('active').html(html);
              $('.content-quick-add .fieldset-option-enabled', $productCard).hide();
              $('.content-quick-add .fieldset-option-enabled:first', $productCard).show();
            });
        }
      }

      $('body').on('click', '.product-card-wrapper[data-product-id] .media ', (event) => {
        window.location = $(event.currentTarget).data('product-url');
      });

      $('body').on('click', '.product-card-wrapper[data-product-id] .content-quick-add .fieldset-option-enabled input', (event) => {
        const $currentOption = $(event.currentTarget).parent().closest('.fieldset-option-enabled');
        const $variantContent = $(event.currentTarget).parent().closest('.variant-content');
        const $options = $('.fieldset-option-enabled', $variantContent);
        const $button = $('.product-form__submit',$(event.currentTarget).parent().closest('.content-quick-add'));

        let  $nextOption = $currentOption.next();
        $currentOption.hide();

        if($nextOption.hasClass('fieldset-option-disabled')) {
          $nextOption = $nextOption.next();
        }
        if($nextOption.hasClass('fieldset-option-enabled')) {
          $nextOption.show();
        } else {
          // $button.show();
          setTimeout(() => {
            $button.click();
          }, 500);
        }

      });

      $('body').on('click', '.content-quick-add .reset ', handleGetQuickAdd);

      $('body').on('mouseenter', '.product-card-wrapper[data-product-id]', handleGetQuickAdd)
      .mouseout(function(event) {
        // $('.content-quick-add').removeClass('active');
      })
      .mouseleave(function(event) {
        // $('.content-quick-add').removeClass('active');
      });

      $mainHeader.css('top', $shoppingFreeDeliveryAnnouncementBarWrapper.length ? `${$shoppingFreeDeliveryAnnouncementBarWrapper.height()}px` : '0');

      $body.css('padding-top', `${($shoppingFreeDeliveryAnnouncementBarWrapper.height() || 0) + ($mainHeader.height() || 0)}px`);

      $(window).scroll(function () {
        if($(window).scrollTop() >= 150) {
          $body.addClass('page-scrolled');
        } else {
          $body.removeClass('page-scrolled');
        }
      });


      $(`${sizeGuide.printReference}`).each((index, element) => {
        let $elem = $(element);
        //let productType = $(element).data('product-type').toLocaleLowerCase();
        // let size = window.sizeGuides.find((sizeItem) => sizeItem.product_type.toLocaleLowerCase() === productType);
        let metaGuide = $('fieldset.ref-guide-size').data('guide-size');
        let size = '//oneoneswimwear.com/cdn/shop/files/WhatsApp_Image_2022-02-17_at_9.24.13_AM_1.jpg?v=1738562008';
        let checkGuideSize = true;
        if(size && checkGuideSize == true) {
          if(metaGuide){
            size = metaGuide;
          }
          let html = `
            <button class="size-guies" onclick="$('#size_guide_popup').show()" type="button">
              ${$elem.html()}
            </button>
          `;
          $elem.html(html);

          let popUp = `
            <div id="size_guide_popup" style="display: none;">
              <div class="overlay"></div>
              <div class="size_guide_popup_wrapper">
                <span class="close" onclick="$(this).parent().parent().hide()">+</span>
                <div class="size_guide_popup_image_container custom-scroll scroll-y">
                  <img src="${size}" alt="Size Guide Popup">
                </div>
              </div>
            </div>
          `;

          $('#body').append(popUp);

          $('#size_guide_popup').click(function (event) {
            if(event.target == $('#size_guide_popup')[0] || event.target == $('#size_guide_popup figure')[0]) {
              $('#size_guide_popup').hide();
            }
          })
        }

      });


      $('body').on('change', '.mobile-facets__item', (event) => {
        if($('input', $(event.currentTarget)).prop("checked")) {
          $(event.currentTarget).addClass('list-menu__item-checked');
        } else  {
          $(event.currentTarget).removeClass('list-menu__item-checked');
        }
      })

    }, 2000);

    setTimeout(function(){
      // var flagBar = true;

      // $('.single-option-selector').change(function(){
      //     setTimeout(function(){
      //       $('.single-option-selector').each(function(){
      //         console.log($(this).val());
      //         if($(this).val() == 'Choose'){
      //           flagBar = false;
      //           console.log('Choose');
      //         }
      //       });
      //       console.log(flagBar);
      //       if( flagBar ){
      //           $('.great_buy_btn button').removeAttr('disabled');
      //       }else{
      //           $('.great_buy_btn button').attr('disabled','true');
      //       }
      //       console.log('change', $(this).val());
      //     }, 1500);
      // });
      $('#great_sticky_bar').addClass('great_sticky_bar_active');
      $('#great_sticky_bar .single-option-selector').prepend('<option selected>Choose</option>');
      $('#great_sticky_bar .great_buy_btn').append('<button type="submit" name="add" class="product-form__submit button button--full-width button--primary">ADD TO BAG</button>');
      $('#great_sticky_bar .great_buy_btn button').attr('disabled','true');
      $('#great_sticky_bar').css({'display': 'block'});

    }, 11000);


  });


  let getMoreProductsSearch = () => {
    const querySearchParams = new URLSearchParams(window.location.search)
    currentPageSearch = querySearchParams.get('page') || currentPageSearch;
    $('#btnLoadMoreProductsSearch').prop('disabled', true)
    const { SearchLoadMore } = window.smk.search;
    const productGridNameRef = '.content-product-list-search';
    loadingCollection = true;
    querySearchParams.set('page', currentPageSearch + 1)
    SearchLoadMore(querySearchParams)
    .then((response) => {
      currentPageSearch++;
      loadingCollection = false;
      const $ul = $(productGridNameRef, $(response));
      const $items = $('.grid__item', $ul);
      if($items.length) {
       $(productGridNameRef).append($items);
      } else {
        $('#btnLoadMoreProductsSearch').hide();
      }
    }).always(() => $('#btnLoadMoreProductsSearch').prop('disabled', false));
  }